import * as Services from "../../Service/Service";
import * as Url from "../../Service/Url";

export const ClinicalFormFillupRequest = async (userid, comment) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.SEND_CLINICAL_FORM_FILL_UP_REQUEST +
      `userid=${userid}&comment=${comment}`,
    null,
    token
  );
  return res;
};

export const GetClinicalFormFillupRequestList = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_CLINICAL_FORM_FILL_UP_REQUEST_LIST,
    token
  );
  return res;
};

export const ApproveClinicalFormFillupRequest = async (
  Id,
  ApprovedBy,
  ApprovedStatus
) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.APPROVE_CLINICAL_FORM_FILL_UP_REQUEST +
      `Id=${Id}&ApprovedBy=${ApprovedBy}&ApprovedStatus=${ApprovedStatus}`,
    null,
    token
  );
  return res;
};

export const CreateSBARRequest = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SBAR_INTAKE_REQUEST, payload, token);
  return res;
};

export const GetSBARRequestListWithPagination = async (
  userId,
  pageNumber,
  pageSize,
  statusFilter
) => {
  try {
    const token = localStorage.getItem("token");
    const res = await Services.GET(
      Url.GET_SBAR_INTAK_REQUEST_LIST_WITH_PAGINATION +
        `userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}&statusFilter=${statusFilter}`,
      token
    );
    return res;
  } catch (error) {
    console.error("Error fetching SBAR request list:", error);
    throw error;
  }
};

export const CompleteOrCancelSBARRequest = async (id, userId, status) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.COMPLETEORCANCELSBARREQUEST +
      `id=${id}&userId=${userId}&approvedStatus=${status}`,
    "",
    token
  );
  return res;
};

export const MarketScanManagementFormFillupRequest = async (userid, comment) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.SEND_MARKET_SCAN_MANAGEMENT_FORM_FILL_UP_REQUEST +
      `userid=${userid}&comment=${comment}`,
    null,
    token
  );
  return res;
};

export const GetMarketScanManagementRequestList = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_MARKET_SCAN_MANAGEMENT_LIST,
    token
  );
  return res;
};

export const ApproveMarketScanManagementRequest = async (
  Id,
  ApprovedBy,
  ApprovedStatus
) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.APPROVE_MARKET_SCAN_MANAGEMENT_REQUEST +
      `Id=${Id}&ApprovedBy=${ApprovedBy}&ApprovedStatus=${ApprovedStatus}`,
    null,
    token
  );
  return res;
};

